export default "__VITE_ASSET__e9IsiUqv__"